export const REGEX_VALID_IMAGE_FORMATS = /gif|jpe?g|[^a]png|svg|webp/i
export const REGEX_VALID_RASTER_IMAGE_FORMATS = /gif|jpe?g|[^a]png|webp/i
